/* ============================================================
   Product page — custom metafield add-on variant system
   Ported from Current-Theme/assets/custom.js (product-page logic).
   Handles: add-on selection, combined price display (#addonsprice),
   and the custom multi-item add-to-cart (#custom_addtocart).
   Requires jQuery (loaded on the product page).
   ============================================================ */

(function () {
  if (typeof jQuery === 'undefined') return;

  jQuery(function ($) {
    // --- Variant / add-on accordion (matches the old theme exactly) ---
    // .itg_variant_show is display:none by default; slideToggle animates the
    // height and flips display:none <-> display:block, just like the old theme.
    // The legend gets .actives_label while open so the "+" icon becomes "−".
    //
    // Dawn 15 replaces the whole <variant-selects> element on every variant
    // change (the old Dawn 10 theme never did), which would collapse open
    // accordions. We track each accordion's open-state and restore it after the
    // re-render so multiple accordions can stay open — exactly like the old theme.
    var openVariantAccordions = {};

    function accordionKey(labelEl) {
      var vs = labelEl.closest('variant-selects');
      var info = labelEl.closest('product-info');
      var section =
        (vs && vs.getAttribute('data-section')) || (info && info.getAttribute('data-section')) || 'main';
      return section + '::' + (labelEl.textContent || '').replace(/\s+/g, ' ').trim();
    }

    $(document).on('click', '.itg_product .itg_variant_label .form__label', function () {
      $(this).toggleClass('actives_label');
      $(this).closest('.itg_variant_label').find('.itg_variant_show').slideToggle();
      openVariantAccordions[accordionKey(this)] = $(this).hasClass('actives_label');
    });

    function restoreVariantAccordions(root) {
      (root || document)
        .querySelectorAll('.itg_product .itg_variant_label .form__label')
        .forEach(function (labelEl) {
          if (!openVariantAccordions[accordionKey(labelEl)]) return;
          labelEl.classList.add('actives_label');
          var fieldset = labelEl.closest('.itg_variant_label');
          var show = fieldset && fieldset.querySelector('.itg_variant_show');
          if (show) show.style.display = 'block';
        });
    }

    // Re-apply the open-state after Dawn re-renders the variant picker.
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('product-info').then(function () {
        var ProductInfoClass = customElements.get('product-info');
        if (!ProductInfoClass || !ProductInfoClass.prototype.updateOptionValues) return;
        var original = ProductInfoClass.prototype.updateOptionValues;
        ProductInfoClass.prototype.updateOptionValues = function (html) {
          original.call(this, html);
          try {
            restoreVariantAccordions(this);
          } catch (e) {
            /* no-op */
          }
        };
      });
    }

    // --- Custom add-to-cart button reveal (legacy class swap) ---
    $(document).on('click', '.itgcustom_variant label', function () {
      $('.metafiled_btn').show();
      $('.theme_addcartbtn').hide();
    });

    // Scope queries to the product-info that contains the clicked element, so
    // the logic targets the right product when a Quick View overlays a product
    // page (two product forms on the page at once). Falls back to the document.
    function ctx($el) {
      var $c = $el.closest('product-info');
      return $c.length ? $c : $(document);
    }

    // Recompute #addonsprice = main price + sum of selected add-on prices.
    function recalcAddonPrice($context) {
      var $addons = $context.find('#addonsprice');
      if (!$addons.length) return;
      var mainprice = parseFloat(($addons.attr('data-main-price') || '0').replace(/[$,]/g, '')) || 0;
      var total = 0;
      $context.find('label.radioval.active').each(function () {
        total += parseFloat($(this).attr('data-variant_price')) || 0;
      });
      $addons.text('$' + (mainprice + total).toFixed(2));
    }

    // --- Add-on selection + combined price calculation ---
    $(document).on('click', '.itg_var_flex label', function () {
      $(this).closest('.multiple_productlist').find('label').removeClass('active');
      $(this).addClass('active');
      recalcAddonPrice(ctx($(this)));
    });

    // Recalculate after the standard variant picker changes (price may update).
    $(document).on('click', '.itg_variant_label label', function () {
      var $context = ctx($(this));
      setTimeout(function () {
        recalcAddonPrice($context);
      }, 1100);
    });

    // --- Custom multi-item add-to-cart (main product + selected add-ons) ---
    $(document).on('click', '#custom_addtocart', function () {
      var $context = ctx($(this));
      var varid = $context.find('.product-variant-id').val();
      var varqty = $context.find('.itg_quantity_addcart .quantity__input').val();
      $(this).find('.custom_loader').removeClass('hidden');
      $(this).css('background-color', '#320b0db8');
      $(this).find('span').hide();
      $(this).find('.custom_loader svg circle').css('stroke', '#fff');

      var randomnumber = 1 + Math.floor(Math.random() * 1000);

      var available_ids = [];
      $context.find('label.radioval.active').each(function () {
        var thisQty = varqty;
        var xVarID = $(this).attr('for');
        var toPushItem = xVarID + '-' + thisQty;
        available_ids.push(toPushItem);
      });

      var arrylength = available_ids.length;
      if (arrylength == 0) {
        var dataarr = {
          id: varid,
          quantity: varqty
        };
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: dataarr,
          dataType: 'json',
          success: function () {
            window.location.href = '/cart';
          }
        });
      } else {
        for (var i = 0; i < available_ids.length; i++) {
          (function (i) {
            setTimeout(function () {
              var formContents = available_ids[i].split('-');
              var datacart = {
                id: formContents[0],
                quantity: formContents[1],
                properties: {
                  Rno: randomnumber
                }
              };
              var params = {
                type: 'POST',
                url: '/cart/add.js',
                data: datacart,
                dataType: 'json',
                success: function () {
                  var iteration_length = i + 1;
                  if (iteration_length == available_ids.length) {
                    var dataarr = {
                      id: varid,
                      quantity: varqty,
                      properties: {
                        Rno: randomnumber
                      }
                    };
                    jQuery.ajax({
                      type: 'POST',
                      url: '/cart/add.js',
                      data: dataarr,
                      dataType: 'json',
                      success: function () {
                        window.location.href = '/cart';
                      }
                    });
                  }
                },
                error: function () {
                  console.log('fail');
                }
              };
              $.ajax(params);
            }, 1000 * i);
          })(i);
        }
      }
    });

    // --- Cart page: remove a grouped add-on item set together ---
    $(document).on('click', '.custom_remove_item', function () {
      var thsnum = $(this).attr('data-num');
      var data = { updates: {} };
      $(document).find('#main-cart-items .cart-item').each(function () {
        var datanumber = $(this).attr('data-number');
        if (datanumber == thsnum) {
          var thisKey = $(this).attr('data-key');
          data.updates[thisKey] = 0;
        }
      });
      jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function () {
          window.location.reload();
        }
      });
    });
  });
})();
